import axios from 'axios';
import * as query from '@arcgis/core/rest/query';

// Configs
import { ADMIN_2_VECTOR_DATA } from '../configs/api.configs';

/**
 * Get the max record count for the admin 2 vector data
 * @param {string} url - The url to the admin 2 vector data
 * @returns {Promise<number>} - The max record count
 */
const getMaxRecordCount = async (url: string) => {
  const results = await axios({
    method: 'GET',
    url: url,
    params: {
      f: 'json',
    },
  }).catch((error) => {
    console.error(error);
  });

  return results?.data?.maxRecordCount;
};

/**
 * Get the admin 2 vector data
 * @param {[]} features - The features
 * @param {number} maxRecordCount - The max record count
 */
export const getMapServerAdmin2Data: any = async (features: [] = [], maxRecordCount: number | undefined) => {
  if (!maxRecordCount) {
    maxRecordCount = await getMaxRecordCount(ADMIN_2_VECTOR_DATA);
  }

  const outFieldsList = [
    'adm2_name',
    'adm1_name',
    'adm0_name',
    'region_id',
    'year',
    'value',
    'width_ci',
    'lower_ci',
    'upper_ci',
    'pop_estimate',
    'DHS_CountryCode',
    'IndicatorID',
  ];
  const queryParams = {
    where: '1=1',
    // outFields: ['*'],
    outFields: [outFieldsList.join()],
    start: features.length,
    num: maxRecordCount,
  };

  try {
    const results: __esri.FeatureSet | void = await query.executeQueryJSON(ADMIN_2_VECTOR_DATA, queryParams);

    const resultsJSON = results?.toJSON();
    const featuresAll = [...features, ...resultsJSON.features];
    if (results?.exceededTransferLimit === true) {
      return await getMapServerAdmin2Data(featuresAll, maxRecordCount);
    } else {
      return featuresAll;
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};
